import { PageContent } from 'components/layout/PageContent'
import { AgendamentosCidadaoView } from 'view/agenda/cidadao/AgendamentosCidadaoView'
import { TipoAtendimentoFooter } from 'view/atendimentos/model-atendimento'

import { AtendimentoFooter } from '../AtendimentoFooter'

export interface AgendamentosCidadaoAtendimentoViewProps {
  atendimentoId: ID
  isRegistroTardio?: boolean
  isAtendimentoObservacao?: boolean
  isObservacaoAndResponsavel?: boolean
  clearCache(updateState?: boolean): void
  tipoAtendimentoProfissional: TipoAtendimentoFooter
}

export function AgendamentosCidadaoAtendimentoView(props: AgendamentosCidadaoAtendimentoViewProps) {
  const {
    atendimentoId,
    clearCache,
    tipoAtendimentoProfissional,
    isRegistroTardio = false,
    isAtendimentoObservacao = false,
    isObservacaoAndResponsavel = false,
  } = props

  return (
    <>
      <PageContent fluid type='filled'>
        <AgendamentosCidadaoView />
      </PageContent>
      <AtendimentoFooter
        atendimentoId={atendimentoId}
        tipoAtendimentoProfissional={tipoAtendimentoProfissional}
        clearCache={clearCache}
        isRegistroTardio={isRegistroTardio}
        isAtendimentoObservacao={isAtendimentoObservacao}
        isObservacaoAndResponsavel={isObservacaoAndResponsavel}
      />
    </>
  )
}
